export default __webpack_public_path__ + "static/media/wi-night-thunderstorm.033ea521.svg";